import React from 'react';
type StatusType = 'Pending' | 'Disbursed' | 'Active' | 'Settled' | 'Due' | 'Overdue' | 'Upcoming' | 'Disbursement Ready' | 'Success' | 'Failure';
interface StatusBadgeProps {
  status: string;
}
export function StatusBadge({
  status
}: StatusBadgeProps) {
  const getStatusStyles = (status: string) => {
    const s = status.toLowerCase();
    if (s.includes('pending') || s.includes('due') || s.includes('upcoming')) {
      return 'bg-amber-100 text-amber-800 border-amber-200';
    }
    if (s.includes('disbursed') || s.includes('active') || s.includes('success') || s.includes('settled')) {
      return 'bg-emerald-100 text-emerald-800 border-emerald-200';
    }
    if (s.includes('overdue') || s.includes('failure') || s.includes('rejected')) {
      return 'bg-red-100 text-red-800 border-red-200';
    }
    if (s.includes('ready')) {
      return 'bg-blue-100 text-blue-800 border-blue-200';
    }
    return 'bg-gray-100 text-gray-800 border-gray-200';
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${getStatusStyles(status)}`} data-id="element-525">
      {status}
    </span>;
}